var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-button-menu icon transparent",class:_vm.className,on:{"click":_vm.Handle_OnClick}},[_c('img',{attrs:{"src":require("@/Asset/image/icon/menu.svg"),"alt":"Menu"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }